import React from "react";
import { STATUS_STYLES, STATUS_DOT } from "@/lib/lorryApi";

export default function StatusBadge({ status }) {
  const key = (status || "pending").toLowerCase();
  const cls = STATUS_STYLES[key] || STATUS_STYLES.pending;
  const dot = STATUS_DOT[key] || STATUS_DOT.pending;
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={`inline-flex items-center gap-2 px-2.5 py-1 border ${cls} text-[0.7rem] tracking-[0.15em] uppercase font-semibold rounded-sm`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      {key}
    </span>
  );
}
